import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {AnalysisGraphQL, GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import AdditionalEditorSection from 'analysis-tool/ui/components/AdditionalEditorSection';
import {getTableLineageAncestorSteps} from 'pipelines/StepLineageUtils';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import * as Colors from 'ui-library/Colors';

import {
  SHARED_CONFIRMATION_BUTTON_STYLES,
  SHARED_RIGHT_PANE_STYLES,
  SHARED_RIGHT_PANE_FOOTER_STYLES,
} from '../charting/ChartViewStepEditorConstants';
import {getTransformPills} from '../charting/TransformPillUtils';

export interface DataFrameViewTransformationSidebarProps {
  analysis: AnalysisGraphQL;
  /**
   * Step at the start of a view lineage
   */
  step: GetAnalysisPipelineStep;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

/**
 * TODO(BNCH-89823): This is a temporary component to allow a sidebar experience for users at the top
 * level of the analysis tool, A more complete experience with all transforms is planned after beta.
 */
export default function DataFrameViewTransformationSidebar({
  analysis,
  step,
  isOpen,
  setIsOpen,
}: DataFrameViewTransformationSidebarProps): JSX.Element {
  const viewSteps = getTableLineageAncestorSteps(analysis, step);

  if (!isOpen) {
    return <></>;
  }

  return (
    <div className={css(styles.rightPane)}>
      <AdditionalEditorSection
        title="Transformations"
        addItemElement={<></>} // TODO(BNCH-89823): Allow adding transformations via a plus icon
        pills={getTransformPills(analysis, viewSteps)}
        showTopBorder={false}
        className={css(styles.additionalEditorSection)}
      />
      <div className={css(styles.rightPaneFooter)}>
        <Button
          buttonStyle={ButtonStyle.SECONDARY}
          fullWidth={true}
          className={css(styles.confirmationButton)}
          size={ButtonSize.MEDIUM}
          onClick={() => {
            setIsOpen(false);
          }}
          text="Close"
        />
      </div>
    </div>
  );
}

export const styles = StyleSheet.create({
  additionalEditorSection: {
    marginBottom: 16,
  },
  confirmationButton: SHARED_CONFIRMATION_BUTTON_STYLES,
  rightPane: {
    ...SHARED_RIGHT_PANE_STYLES,
    background: Colors.WHITE,
  },
  rightPaneFooter: SHARED_RIGHT_PANE_FOOTER_STYLES,
});
